import { ThemeIcon, TypographyStylesProvider } from "@mantine/core";
import {
  IconAbacus,
  IconApps,
  IconArrowBigDownFilled,
  IconArrowBigUpFilled,
  IconAt,
  IconBolt,
  IconBoltFilled,
  IconCircleDashedCheck,
  IconCircleMinus,
  IconClock,
  IconCoinBitcoinFilled,
  IconExchange,
  IconFileInvoice,
  IconInfoCircle,
  IconKey,
  IconPlugConnected,
  IconRocket,
  IconUsers,
  IconWriting,
  IconSettings,
  IconDatabase,
  IconAlertOctagon,
  IconTrash,
  IconAlertTriangle,
  IconHexagonLetterAFilled,
  IconKeyFilled,
  IconArrowLeft,
  IconArrowsLeftRight,
  IconHexagonLetterSFilled,
  IconUserCheck,
  IconHexagonLetterBFilled,
} from "@tabler/icons-react";
import React from "react";
import ArticleIcon from "./articlesHelpers/ArticleIcon";
import { NODE_STATUS_CONTENT } from "./articles/nodeStatus";
import { BTC_BALANCE_CONTENT } from "./articles/btcBalance";
import { INBOUND_BALANCE_CONTENT } from "./articles/inboundCapacity";
import { OUTBOUND_CAPACITY_CONTENT } from "./articles/outboundCapacity";
import { GET_INBOUND_CONTENT } from "./articles/getInbound";
import { RECEIVING_LIGHTNING_PAYMENTS_CONTENT } from "./articles/receivingLightningPayments";
import { RECEIVE_TO_LIGHTNING_ADDRESS_CONTENT } from "./articles/receiveToLightningAddress";
import { RECEIVE_TO_LIGHTNING_INVOICE_CONTENT } from "./articles/receiveToLightningInvoice";
import { SEND_TO_LIGHTNING_ADDRESS_CONTENT } from "./articles/sendToLightningAddress";
import { SEND_TO_LIGHTNING_INVOICE_CONTENT } from "./articles/sendToLightningInvoice";
import { SEND_TO_KEYSEND_CONTENT } from "./articles/sendToKeysend";
import { SENDING_LIGHTNING_PAYMENTS_CONTENT } from "./articles/sendingLightningPayments";
import { DEPOSIT_BTC_CONTENT } from "./articles/depositBTC";
import { WITHDRAW_BTC_CONTENT } from "./articles/withdrawBTC";
import { PENDING_BTC_BALANCE_CONTENT } from "./articles/pendingBtcBalance";
import { OPENING_CHANNELS_CONTENT } from "./articles/openingChannels";
import { CLOSING_CHANNELS_CONTENT } from "./articles/closingChannels";
import { CHANNEL_INFO_CONTENT } from "./articles/channelInfo";
import { ADD_PEERS_CONTENT } from "./articles/addPeers";
import { PEERS_CONTENT } from "./articles/peers";

import { GAURENTEED_UPTIME_CONTENT } from "./articles/guranteedUptime";
import { NODE_INFO_AND_ALIAS_CONTENT } from "./articles/nodeInfoAndAlias";
import { SIGN_MESSAGE_CONTENT } from "./articles/sign-message";
import { SETTINGS_CONTENT } from "./articles/settings";
import { NODE_DATA_CONTENT } from "./articles/node-data";
import { LIGHTNING_SENT_CONTENT } from "./articles/lightning-sent";
import { LIGHTNING_RECEIVED_CONTENT } from "./articles/lightning-received";
import { BITCOIN_WITHDRAWALS_CONTENT } from "./articles/bitcoin-withdrawals";
import { ONCHAIN_TRANSACTIONS_CONTENT } from "./articles/onchain-transactions";
import { ERRORS_CONTENT } from "./articles/errors";
import { CLOSED_CHANNELS_CONTENT } from "./articles/closed-channels";
import { DELETING_YOUR_NODE_CONTENT } from "./articles/deletingYourNode";
import { DELETING_YOUR_ACCOUNT_CONTENT } from "./articles/deletingYourAccount";
import { USE_RIZFUL_WITH_ALBY_BROWSER_EXTENSION } from "./howToArticles/useRizfulWithAlbyBrowserExtension";
import { NOSTR_GET_PUBLIC_KEY_CONTENT } from "./articles/nostrGetPublicKey";
import { NOSTR_GET_PRIVATE_KEY_CONTENT } from "./articles/nostrGetPrivateKey";
import { NOSTR_WALLET_CONNECT_RECEIVE_CONTENT } from "./articles/nostrWalletConnectReceive";
import { NOSTR_WALLET_CONNECT_SEND_AND_RECEIVE_CONTENT } from "./articles/nostrWalletConnectSendAndReceive";
import { USE_RIZFUL_WITH_STACKER_NEWS } from "./howToArticles/useRizfulWithStackerNews";
import { YOUR_NOSTR_IDENTITY_CONTENT } from "./articles/yourNostrIdentity";
import { USE_RIZFUL_BTC_PAY_SERVER } from "./howToArticles/useRizfulWithBtcPayServer";

export type Article = {
  title: string;
  slug: string;
  icon: any;
  content: string;
};

export type Page = {
  title: string;
  slug: string;
  ARTICLES: Article[];
};

// Import the JSON file
import articlesData from "../../../constants/articles.json"; // assert { type: "json" };
// console.log("data from json file", articlesData);

const createArticle = (title, slug, icon, content, subtitle = "") => {
  return {
    title,
    slug,
    icon: (
      <ArticleIcon
        ariaLabel={slug} // Using slug for both aria-label and slug
        icon={icon}
      />
    ),
    content,
    subtitle,
  };
};
// Create a lookup map from articles.json
const articleTitleMap = new Map(
  articlesData.map(({ slug, title }) => [slug, title])
);

export const ARTICLES = {
  NODE_STATUS: createArticle(
    articleTitleMap.get("what-is-node-status"),
    "what-is-node-status",
    <IconCircleDashedCheck />,
    NODE_STATUS_CONTENT,
    "Stopped, Starting, or Running"
  ),
  GET_GUARANTEED_UPTIME: createArticle(
    articleTitleMap.get("guaranteed-uptime"),
    "guaranteed-uptime",
    <IconClock />,
    GAURENTEED_UPTIME_CONTENT
  ),
  NODE_INFO_AND_ALIAS: createArticle(
    articleTitleMap.get("node-info-and-alias"),
    "node-info-and-alias",
    <IconInfoCircle />,
    NODE_INFO_AND_ALIAS_CONTENT
  ),
  // YOUR_NOSTR_IDENTITY: createArticle(
  //   articleTitleMap.get("your-nostr-identity"),
  //   "your-nostr-identity",
  //   <IconUserCheck />,
  //   YOUR_NOSTR_IDENTITY_CONTENT
  // ),
  BTC_BALANCE: createArticle(
    articleTitleMap.get("btc-balance"),
    "btc-balance",
    <IconCoinBitcoinFilled />,
    BTC_BALANCE_CONTENT
  ),
  INBOUND_BALANCE: createArticle(
    articleTitleMap.get("inbound-capacity"),
    "inbound-capacity",
    <IconBolt />,
    INBOUND_BALANCE_CONTENT
  ),
  OUTBOUND_BALANCE: createArticle(
    articleTitleMap.get("outbound-capacity"),
    "outbound-capacity",
    <IconBoltFilled />,
    OUTBOUND_CAPACITY_CONTENT
  ),
  PENDING_BALANCE: createArticle(
    articleTitleMap.get("pending-btc-balance"),
    "pending-btc-balance",
    <IconClock />,
    PENDING_BTC_BALANCE_CONTENT
  ),
  GET_INBOUND: createArticle(
    articleTitleMap.get("inbound-from-rizful-lsp"),
    "inbound-from-rizful-lsp",
    <IconRocket />,
    GET_INBOUND_CONTENT
  ),
  RECEIVING_LIGHTNING_PAYMENTS: createArticle(
    articleTitleMap.get("receiving-lightning-payments"),
    "receiving-lightning-payments",
    <IconBolt />,
    RECEIVING_LIGHTNING_PAYMENTS_CONTENT
  ),
  RECEIVE_TO_LIGHTNING_ADDRESS: createArticle(
    articleTitleMap.get("receiving-to-lightning-address"),
    "receiving-to-lightning-address",
    <IconAt />,
    RECEIVE_TO_LIGHTNING_ADDRESS_CONTENT
  ),
  RECEIVE_TO_LIGHTNING_INVOICE: createArticle(
    articleTitleMap.get("receiving-to-lightning-invoice"),
    "receiving-to-lightning-invoice",
    <IconFileInvoice />,
    RECEIVE_TO_LIGHTNING_INVOICE_CONTENT
  ),
  SENDING_LIGHTNING_PAYMENTS: createArticle(
    articleTitleMap.get("sending-lightning-payments"),
    "sending-lightning-payments",
    <IconBoltFilled />,
    SENDING_LIGHTNING_PAYMENTS_CONTENT
  ),
  SENDING_TO_LIGHTING_ADDRESS: createArticle(
    articleTitleMap.get("pay-to-lightning-address"),
    "pay-to-lightning-address",
    <IconAt />,
    SEND_TO_LIGHTNING_ADDRESS_CONTENT
  ),
  SENDING_TO_LIGHTING_INVOICE: createArticle(
    articleTitleMap.get("pay-to-lightning-invoice"),
    "pay-to-lightning-invoice",
    <IconFileInvoice />,
    SEND_TO_LIGHTNING_INVOICE_CONTENT
  ),
  SENDING_TO_KEYSEND: createArticle(
    articleTitleMap.get("keysend-payments"),
    "keysend-payments",
    <IconKey />,
    SEND_TO_KEYSEND_CONTENT
  ),
  DEPOSIT_BTC: createArticle(
    articleTitleMap.get("deposit-btc"),
    "deposit-btc",
    <IconArrowBigDownFilled />,
    DEPOSIT_BTC_CONTENT
  ),
  WITHDRAW_BTC: createArticle(
    articleTitleMap.get("withdraw-btc"),
    "withdraw-btc",
    <IconArrowBigUpFilled />,
    WITHDRAW_BTC_CONTENT
  ),
  OPENING_CHANNELS: createArticle(
    articleTitleMap.get("opening-channels"),
    "opening-channels",
    <IconExchange />,
    OPENING_CHANNELS_CONTENT
  ),
  CLOSING_CHANNELS: createArticle(
    articleTitleMap.get("closing-channels"),
    "closing-channels",
    <IconCircleMinus />,
    CLOSING_CHANNELS_CONTENT
  ),
  CHANNEL_INFO: createArticle(
    articleTitleMap.get("channel-info"),
    "channel-info",
    <IconAbacus />,
    CHANNEL_INFO_CONTENT
  ),
  ADD_PEER: createArticle(
    articleTitleMap.get("add-peer"),
    "add-peer",
    <IconPlugConnected />,
    ADD_PEERS_CONTENT
  ),
  NOSTR_GET_PUBLIC_KEY: createArticle(
    articleTitleMap.get("get-nostr-public-key"),
    "get-nostr-public-key",
    <IconKey />,
    NOSTR_GET_PUBLIC_KEY_CONTENT
  ),
  NOSTR_GET_PRIVATE_KEY: createArticle(
    articleTitleMap.get("get-nostr-private-key"),
    "get-nostr-private-key",
    <IconKeyFilled />,
    NOSTR_GET_PRIVATE_KEY_CONTENT
  ),
  NWC_RECEIVE: createArticle(
    articleTitleMap.get("nostr-wallet-connect-receive-only"),
    "nostr-wallet-connect-receive-only",
    <IconArrowLeft />,
    NOSTR_WALLET_CONNECT_RECEIVE_CONTENT
  ),
  NWC_SEND_AND_RECEIVE: createArticle(
    articleTitleMap.get("nostr-wallet-connect-send-and-receive"),
    "nostr-wallet-connect-send-and-receive",
    <IconArrowsLeftRight />,
    NOSTR_WALLET_CONNECT_SEND_AND_RECEIVE_CONTENT
  ),
  SIGN_MESSAGE: createArticle(
    articleTitleMap.get("sign-message"),
    "sign-message",
    <IconWriting />,
    SIGN_MESSAGE_CONTENT
  ),
  SETTINGS: createArticle(
    articleTitleMap.get("settings"),
    "settings",
    <IconSettings />,
    SETTINGS_CONTENT
  ),
  NODE_DATA: createArticle(
    articleTitleMap.get("node-data"),
    "node-data",
    <IconDatabase />,
    NODE_DATA_CONTENT
  ),
  LIGHTNING_SENT: createArticle(
    articleTitleMap.get("lightning-sent"),
    "lightning-sent",
    <IconBoltFilled />,
    LIGHTNING_SENT_CONTENT
  ),
  LIGHTNING_RECEIVED: createArticle(
    articleTitleMap.get("lightning-received"),
    "lightning-received",
    <IconBolt />,
    LIGHTNING_RECEIVED_CONTENT
  ),
  BITCOIN_WITHDRAWALS: createArticle(
    articleTitleMap.get("bitcoin-withdrawals"),
    "bitcoin-withdrawals",
    <IconArrowBigUpFilled />,
    BITCOIN_WITHDRAWALS_CONTENT
  ),
  ONCHAIN_TRANSACTIONS: createArticle(
    articleTitleMap.get("onchain-transactions"),
    "onchain-transactions",
    <IconCoinBitcoinFilled />,
    ONCHAIN_TRANSACTIONS_CONTENT
  ),
  ERRORS: createArticle(
    articleTitleMap.get("errors"),
    "errors",
    <IconAlertOctagon />,
    ERRORS_CONTENT
  ),
  CLOSED_CHANNELS: createArticle(
    articleTitleMap.get("closed-channels"),
    "closed-channels",
    <IconCircleMinus />,
    CLOSED_CHANNELS_CONTENT
  ),
  DELETING_YOUR_NODE: createArticle(
    articleTitleMap.get("deleting-your-node"),
    "deleting-your-node",
    <IconTrash />,
    DELETING_YOUR_NODE_CONTENT
  ),
  DELETING_YOUR_ACCOUNT: createArticle(
    articleTitleMap.get("deleting-your-account"),
    "deleting-your-account",
    <IconAlertTriangle />,
    DELETING_YOUR_ACCOUNT_CONTENT
  ),
  USE_RIZFUL_WITH_ALBY_BROWSER_EXTENSION: createArticle(
    articleTitleMap.get("use-rizful-alby-browser-extension"),
    "use-rizful-alby-browser-extension",
    <IconHexagonLetterAFilled />,
    USE_RIZFUL_WITH_ALBY_BROWSER_EXTENSION
  ),
  USE_RIZFUL_WITH_STACKER_NEWS: createArticle(
    articleTitleMap.get("use-rizful-with-stacker-news"),
    "use-rizful-with-stacker-news",
    <IconHexagonLetterSFilled />,
    USE_RIZFUL_WITH_STACKER_NEWS
  ),
  USE_RIZFUL_BTC_PAY_SERVER: createArticle(
    articleTitleMap.get("use-rizful-btcpayserver"),
    "use-rizful-btcpayserver",
    <IconHexagonLetterBFilled />,
    USE_RIZFUL_BTC_PAY_SERVER
  ),
};

export const PAGES = {
  GETTING_STARTED: {
    title: "About My Node",
    slug: "lightning-node-basics",
    ARTICLES: [
      ARTICLES.NODE_STATUS,
      ARTICLES.GET_GUARANTEED_UPTIME,
      ARTICLES.NODE_INFO_AND_ALIAS,
      //ARTICLES.YOUR_NOSTR_IDENTITY,
    ],
  },
  BALANCES: {
    title: "BTC Balance & Lightning Capacity",
    slug: "balances-and-capacities",
    ARTICLES: [
      ARTICLES.BTC_BALANCE,
      ARTICLES.PENDING_BALANCE,
      ARTICLES.INBOUND_BALANCE,
      ARTICLES.OUTBOUND_BALANCE,
    ],
  },
  GETTING_INBOUND: {
    title: "Getting Inbound",
    slug: "getting-inbound",
    ARTICLES: [ARTICLES.GET_INBOUND],
  },
  RECEIVING_LIGHTNING_PAYMENTS: {
    title: "Inbound Lightning Payments",
    slug: "receiving-payments",
    ARTICLES: [
      ARTICLES.RECEIVING_LIGHTNING_PAYMENTS,
      ARTICLES.RECEIVE_TO_LIGHTNING_ADDRESS,
      ARTICLES.RECEIVE_TO_LIGHTNING_INVOICE,
    ],
  },
  SENDING_LIGHTNING_PAYMENTS: {
    title: "Outbound Lightning Payments",
    slug: "sending-payments",
    ARTICLES: [
      ARTICLES.SENDING_LIGHTNING_PAYMENTS,
      ARTICLES.SENDING_TO_LIGHTING_ADDRESS,
      ARTICLES.SENDING_TO_LIGHTING_INVOICE,
      ARTICLES.SENDING_TO_KEYSEND,
    ],
  },
  DEPOSIT_AND_WITHDRAW_BTC: {
    title: "Deposit & Withdraw BTC",
    slug: "deposit-withdraw-btc",
    ARTICLES: [ARTICLES.DEPOSIT_BTC, ARTICLES.WITHDRAW_BTC],
  },
  CHANNEL_OPERATIONS: {
    title: "Channel Operations",
    slug: "opening-channels",
    ARTICLES: [
      ARTICLES.OPENING_CHANNELS,
      ARTICLES.CLOSING_CHANNELS,
      ARTICLES.CHANNEL_INFO,
      ARTICLES.ADD_PEER,
    ],
  },
  // CONNECT_APPS: {
  //   title: "Connecting Apps",
  //   slug: "connecting-apps",
  //   ARTICLES: [
  //     ARTICLES.NOSTR_GET_PUBLIC_KEY,
  //     ARTICLES.NOSTR_GET_PRIVATE_KEY,
  //     ARTICLES.NWC_RECEIVE,
  //     ARTICLES.NWC_SEND_AND_RECEIVE,
  //   ],
  // },
  TOOLS: {
    title: "Tools",
    slug: "tools",
    ARTICLES: [ARTICLES.SIGN_MESSAGE, ARTICLES.SETTINGS, ARTICLES.NODE_DATA],
  },
  HISTORY: {
    title: "History",
    slug: "history",
    ARTICLES: [
      ARTICLES.LIGHTNING_SENT,
      ARTICLES.LIGHTNING_RECEIVED,
      ARTICLES.BITCOIN_WITHDRAWALS,
      ARTICLES.ONCHAIN_TRANSACTIONS,
      ARTICLES.ERRORS,
      ARTICLES.CLOSED_CHANNELS,
    ],
  },
  DELETING_YOUR_NODE: {
    title: "Deleting Your Node",
    slug: "deleting-node",
    ARTICLES: [ARTICLES.DELETING_YOUR_NODE, ARTICLES.DELETING_YOUR_ACCOUNT],
  },
  // USE_RIZFUL_WITH_SERVICES: {
  //   title: "Use Rizful with Services",
  //   slug: "use-rizful-with-services",
  //   ARTICLES: [
  //     //ARTICLES.USE_RIZFUL_WITH_ALBY_BROWSER_EXTENSION,
  //     //ARTICLES.USE_RIZFUL_WITH_STACKER_NEWS,
  //     ARTICLES.USE_RIZFUL_BTC_PAY_SERVER,
  //   ],
  // },
};

export const getArticle = (slug: string) => {
  return Object.values(ARTICLES).find((article) => article.slug === slug);
};
